import { createContext } from 'react';

const FavoritesContext = createContext(null);

export default FavoritesContext;
